/*
 * Find your match quiz, <nh-quiz> (sections/nh-i-quiz.liquid), redesign 2026-09-29.
 * The matching rules (groups, bands, scoring, diversity, tips, lube cross-sell) are copied
 * unchanged from assets/nh-i.js (NhiQuiz), which stays untouched for the home page.
 * This file adds: one question per screen with a sticky bar, native radio/checkbox inputs,
 * a sticky CTA, live band counts and thumbnails on the budget step, answer memory
 * (sessionStorage + URL), "why it matched" chips and the results reveal.
 */
(() => {
  'use strict';
  if (customElements.get('nh-quiz')) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const STORE_KEY = 'fym:answers';

  const QUIZ_GROUPS = {
    her: { air: ['air'], wand: ['wand'], rabbit: ['rabbit'], gspot: ['gspot'], bullet: ['bullet', 'egg', 'clit', 'vibe', 'layon'], wear: ['wear'], dildo: ['dildo', 'thrust', 'strapon'], anal: ['plug', 'beads'], lingerie: ['lingerie'] },
    him: { stroker: ['stroker'], auto: ['autostroker'], ring: ['ring', 'vring'], prostate: ['prostate'], anal: ['plug', 'beads'], sleeve: ['sleeve', 'pump'] },
    couples: { cvibe: ['couples', 'wear'], vring: ['vring'], remote: ['@remote'], bondage: ['bondage', 'impact', 'nipple'], furniture: ['furniture', 'machine'], games: ['game', 'kit'], lube: ['lube', 'massage'] },
    first: { bullet: ['bullet', 'egg', 'clit', 'vibe', 'layon'], air: ['air'], rabbit: ['rabbit', 'gspot'], stroker: ['stroker', 'sleeve'], ring: ['ring', 'vring'], couples: ['couples', 'wear'], anal: ['plug', 'prostate'], lube: ['lube', 'massage'] },
  };
  const QUIZ_NOT_SURPRISE = new Set(['lube', 'massage', 'lingerie', 'game', 'kit', 'games']);
  /* Fix D (2026-09-28): accessories and spare parts are never a "match" (replacement heads, storage cases, adapters, chargers, Versa sleeves). */
  const QUIZ_ACCESSORY = /\breplacement\b|\b(?:climax|spare|stimulator|brush|wand|massage)\s+heads?\b|\battachments?\b|\bcharg(?:er|ing (?:cable|cord|base|dock))s?\b|\bstorage\b|\btoy case\b|\badapt[eo]rs?\b|^femme funn versa [a-z] sleeve\b/i;
  const QUIZ_RELATED = {
    air: ['clit', 'bullet'], wand: ['bullet', 'vibe'], rabbit: ['gspot', 'thrust'], gspot: ['rabbit', 'dildo'], bullet: ['egg', 'clit', 'vibe'],
    egg: ['bullet', 'wear'], clit: ['air', 'bullet'], vibe: ['bullet', 'wand'], layon: ['bullet', 'clit'], wear: ['egg', 'couples'],
    dildo: ['gspot', 'thrust'], thrust: ['rabbit', 'dildo'], strapon: ['dildo'], plug: ['beads', 'prostate'], beads: ['plug'],
    lingerie: ['bondage'], stroker: ['sleeve', 'autostroker'], autostroker: ['stroker'], ring: ['vring'], vring: ['ring', 'couples'],
    prostate: ['plug'], sleeve: ['pump', 'stroker'], pump: ['sleeve'], couples: ['vring', 'wear'], bondage: ['impact', 'nipple'],
    impact: ['bondage'], nipple: ['bondage'], furniture: ['machine'], machine: ['furniture'], game: ['kit'], kit: ['game'], lube: ['massage'], massage: ['lube'],
  };
  const QUIZ_BANDS = { u50: [0, 4999], u100: [5000, 9999], u250: [10000, 25000], o250: [25001, Infinity], any: [0, Infinity] };
  const QUIZ_BAND_ORDER = ['u50', 'u100', 'u250', 'o250'];
  const QUIZ_WHY = {
    air: 'Touch-free air-pulse suction for fast, intense clitoral orgasms', wand: 'Deep, rumbly wand vibrations that relax and satisfy',
    rabbit: 'Dual stimulation: G-spot and clitoris at the same time', gspot: 'Curved to find the G-spot with ease', bullet: 'Small, discreet and surprisingly strong',
    egg: 'Hands-free vibrations wherever you want them', clit: 'Focused clitoral pleasure', vibe: 'An easy all-rounder vibrator', layon: 'Lies flat for effortless, hands-free play',
    wear: 'Wearable, hands-free pleasure solo or together', dildo: 'Satisfying fullness, made to be explored', thrust: 'Thrusting motion that does the work for you',
    strapon: 'Built for strap-on play together', plug: 'Comfortable, tapered and made for anal play', beads: 'Graduated beads for a slow, teasing build',
    lingerie: 'Feel irresistible and set the mood', stroker: 'Realistic texture for a better-than-hand feel', autostroker: 'Automatic strokes: sit back and let it do the work',
    ring: 'Adds a firmer feel and staying power', vring: 'Adds vibration to sex for both of you', prostate: 'Angled for prostate pleasure',
    sleeve: 'Adds girth and texture', pump: 'Adds a firmer feel and staying power', couples: 'Designed to be shared during sex', bondage: 'Easy restraint for playful power exchange',
    impact: 'Spanking and sensation play', nipple: 'Nipple play and teasing', furniture: 'Better angles and deeper positions', machine: 'Hands-free, powerful machine play',
    game: 'Fun prompts to spice things up', kit: 'A great-value set to try several toys', lube: 'Smooth, long-lasting glide', massage: 'Sensual massage to set the mood',
    herpump: 'Suction for heightened sensitivity', estim: 'Electro-stimulation for experienced players',
  };
  const QUIZ_TIPS = {
    air: ['Start on the lowest setting and hover rather than press: air-pulse works without direct contact.', 'Tilt the nozzle for a slightly off-centre seal: many find it more intense than straight on.'],
    wand: ['Use a layer of fabric at first: wand vibrations are strong and deep.', 'Pair a wand with a silicone attachment for G-spot play.'],
    rabbit: ['Look for a flexible shaft so the clitoral arm sits where you need it.', 'Try different rhythms for the shaft and arm: independent controls are worth it.'],
    gspot: ['The G-spot is 5 to 7 cm inside on the front wall: a firm, curved tip helps.', 'A firmer, heavier G-spot toy gives more pressure than vibration alone.'],
    bullet: ['A bullet is the easiest first vibrator: small, quiet and easy to hold.', 'Pair a bullet with a cock ring or sleeve for extra versatility.'],
    wear: ['Wearables stay put during sex: practise solo first to find the fit.', 'App control lets a partner tease you from across the room.'],
    dildo: ['Start with a smaller diameter and plenty of water-based lube.', 'Suction-cup bases make hands-free and shower play easy.'],
    anal: ['Anal toys must have a flared base. Go slow and use plenty of thick lube.', 'Graduated sizes and vibrating plugs are the natural next step.'],
    lingerie: ['Choose your usual size; stretch lace forgives a lot.', 'Pair lingerie with light restraints for a full scene.'],
    stroker: ['Use water-based lube and rinse with warm water after every use.', 'A tighter, textured sleeve adds intensity; warm it in warm water first.'],
    auto: ['Automatic strokers are loud-ish: check the noise rating if privacy matters.', 'Pair with interactive content or a partner app for synced play.'],
    ring: ['Start with a stretchy silicone ring and never wear it over 30 minutes.', 'Vibrating rings give both partners something extra during sex.'],
    prostate: ['Relax, go slow and use thick lube: the prostate is 5 cm in, towards the belly.', 'Remote-controlled prostate massagers let a partner take charge.'],
    sleeve: ['Sleeves and pumps work best with water-based lube.', 'Use a pump with a pressure gauge and short sessions.'],
    cvibe: ['Couples vibes sit inside and against the clitoris at once: try it solo first.', 'Pick one with app control for long-distance play.'],
    vring: ['A vibrating ring is the easiest couples toy: no learning curve for either of you.', 'Rechargeable rings are stronger than disposable ones.'],
    remote: ['Remote toys are perfect for teasing: agree a safe word before going out.', 'App control adds long-distance play and custom patterns.'],
    bondage: ['Agree a safe word first and start with soft, easy-release cuffs.', 'Try blindfolds with restraints to heighten every touch.'],
    furniture: ['A wedge makes many positions deeper and more comfortable.', 'Swings and machines open up hands-free play.'],
    games: ['Games are a low-pressure way to talk about what you both want.', 'Kits are great value to discover new favourites.'],
    lube: ['Water-based lube suits every toy. Avoid silicone lube with silicone toys.', 'Silicone lube lasts longest in the shower; oil-based is for massage only.'],
    couples: ['Choose a toy you can both control: rings and wearables are easy wins.', 'Try it solo first so you know what you like together.'],
  };

  const quizEsc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const quizHash = (s) => { let h = 2166136261; for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return (h >>> 0) / 4294967296; };

  const KEYS = ['who', 'cats', 'mood', 'budget', 'exp'];
  const MOOD_N = { gentle: 1, medium: 2, intense: 3 };
  const ICON_BAG = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false"><path d="M5 7h10l-.8 9.2a1 1 0 0 1-1 .8H6.8a1 1 0 0 1-1-.8zM7.5 7V5.5a2.5 2.5 0 0 1 5 0V7" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ICON_TICK = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false"><path d="m4.5 10.5 3.5 3.5 7.5-8" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ICON_EDIT = '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true" focusable="false"><path d="M10.5 2.5l3 3L6 13H3v-3z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';

  class NhQuiz extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const $ = (s) => this.querySelector(s);
      this.stage = $('[data-stage]');
      this.bar = $('[data-bar]');
      this.form = $('[data-form]');
      this.steps = [...this.querySelectorAll('.fym__step')];
      this.backBtn = $('[data-back]');
      this.nextBtn = $('[data-next]');
      this.nextLabel = $('[data-next-label]');
      this.cta = $('[data-cta]');
      this.peekEl = $('[data-peek]');
      this.peekCount = $('[data-peek-count]');
      this.peekThumbs = $('[data-peek-thumbs]');
      this.stepNo = $('[data-stepno]');
      this.names = [...this.querySelectorAll('[data-name]')];
      this.track = $('.fym__track');
      this.fill = $('[data-fill]');
      this.qEl = $('[data-q]');
      this.hintEl = $('.fym__hint');
      this.hintText = $('[data-hint-text]');
      this.meter = $('[data-meter]');
      this.results = $('[data-results]');
      this.resTitle = $('[data-res-title]');
      this.grid = $('[data-grid]');
      this.answersEl = $('[data-answers]');
      this.countEl = $('[data-count]');
      this.widened = $('[data-widened]');
      this.moreBtn = $('[data-more-btn]');
      this.sortSel = $('[data-sort]');
      this.tip = $('[data-tip]');
      this.pairs = $('[data-pairs]');
      this.loading = $('[data-loading]');
      this.seeAll = $('[data-see-all]');
      this.actions = $('.fym__actions');
      this.burst = $('.fym__burst');
      this.status = $('[data-status]');
      try { this.picks = JSON.parse($('[data-picks]')?.textContent || '{}'); } catch { this.picks = {}; }
      this.state = { cats: [] };
      this.data = {};
      this.current = 0;
      this.lastPointer = 0;

      // stagger index for the option entrance
      for (const opts of this.querySelectorAll('.fym__opts')) [...opts.children].forEach((el, i) => el.style.setProperty('--k', i));

      this.addEventListener('pointerdown', (e) => {
        const label = e.target.closest('label');
        if (!label) return;
        this.lastPointer = Date.now();
        const input = label.querySelector('.fym-in');
        this.reTap = input && input.type === 'radio' && input.checked ? input : null;
      });
      this.form.addEventListener('change', (e) => this.#onChange(e));
      this.form.addEventListener('submit', (e) => e.preventDefault());
      this.form.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && e.target.classList?.contains('fym-in')) { e.preventDefault(); this.#next(); }
      });
      this.addEventListener('click', (e) => this.#onClick(e));
      this.sortSel?.addEventListener('change', () => { this.shown = 12; this.#render(); });
      this.liveCache = new Map();

      this.#restore();
      this.#sync();
    }

    /* ---------------- answers ---------------- */
    #group(key) {
      if (key === 'cats') return this.querySelector(`[data-key="cats"][data-for="${CSS.escape(this.state.who || '')}"]`);
      return this.querySelector(`[data-key="${key}"]`);
    }

    #read() {
      const val = (k) => this.#group(k)?.querySelector('.fym-in:checked')?.value;
      this.state.who = val('who');
      this.state.mood = val('mood');
      this.state.budget = val('budget');
      this.state.exp = val('exp');
      const g = this.#group('cats');
      this.state.cats = g ? [...g.querySelectorAll('.fym-in:checked')].map((i) => i.value) : [];
      for (const label of this.querySelectorAll('.fym__opts label')) label.classList.toggle('is-on', !!label.querySelector('.fym-in:checked'));
    }

    #save() {
      try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ who: this.state.who, cats: this.state.cats, mood: this.state.mood, budget: this.state.budget, exp: this.state.exp })); } catch { /* storage unavailable */ }
    }

    #set(key, value, checked = true) {
      const input = this.#group(key)?.querySelector(`.fym-in[value="${CSS.escape(value)}"]`);
      if (input) input.checked = checked;
      return !!input;
    }

    #restore() {
      const params = new URL(window.location.href).searchParams;
      let src = null;
      if (params.get('who')) {
        src = { who: params.get('who'), cats: (params.get('cats') || '').split(',').filter(Boolean), mood: params.get('mood'), budget: params.get('budget'), exp: params.get('exp') };
      } else {
        try { src = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch { src = null; }
      }
      if (!src || !src.who || !this.#set('who', src.who)) { this.#goto(0, true); return; }
      this.#read();
      this.#showCats();
      for (const c of src.cats || []) this.#set('cats', c);
      for (const k of ['mood', 'budget', 'exp']) if (src[k]) this.#set(k, src[k]);
      this.#read();
      this.#load(this.state.who);
      const complete = this.state.cats.length && this.state.mood && this.state.budget && this.state.exp;
      if (params.get('who') && complete) { this.#show(true); return; }
      this.#goto(0, true); // answers are pre-filled; the shopper starts at step 1 and can breeze through
    }

    #showCats() {
      for (const g of this.querySelectorAll('[data-key="cats"]')) g.hidden = g.dataset.for !== this.state.who;
    }

    /** @param {Event} e */
    #onChange(e) {
      const input = e.target;
      if (!input.classList?.contains('fym-in')) return;
      const label = input.closest('label');
      const key = input.closest('[data-key]').dataset.key;
      const byPointer = Date.now() - this.lastPointer < 1200;

      if (key === 'cats') {
        const group = this.#group('cats');
        if (input.checked) {
          for (const other of group.querySelectorAll('.fym-in:checked')) {
            if (other !== input && (input.value === 'surprise' || other.value === 'surprise')) other.checked = false;
          }
        }
      }
      if (key === 'who') {
        this.#read();
        this.#showCats();
        this.#load(this.state.who); // fetch the index as soon as we know the audience
      }
      this.#read();
      this.#save();
      this.#sync();
      if (input.checked) this.#pop(label);

      const advance = byPointer && input.checked && (input.type === 'radio' || input.value === 'surprise');
      if (advance) {
        clearTimeout(this.advT);
        this.advT = setTimeout(() => this.#next(), reduceMotion.matches ? 120 : 380);
      }
    }

    #pop(el) {
      if (navigator.vibrate) { try { navigator.vibrate(8); } catch { /* ignore */ } }
      if (reduceMotion.matches) return;
      el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop');
    }

    #answered(i) {
      const k = KEYS[i];
      return k === 'cats' ? this.state.cats.length > 0 : !!this.state[k];
    }

    /* ---------------- navigation ---------------- */
    #next() {
      if (!this.#answered(this.current)) { this.#nudge(); return; }
      if (this.current < this.steps.length - 1) this.#goto(this.current + 1);
      else this.#show();
    }

    #nudge() {
      this.hintEl.classList.remove('is-nudge'); void this.hintEl.offsetWidth; this.hintEl.classList.add('is-nudge');
      const scope = this.#scope(this.current);
      const opts = scope?.matches?.('.fym__opts') ? scope : scope?.querySelector('.fym__opts');
      const first = scope?.querySelector('.fym-in');
      first?.focus({ preventScroll: true });
      if (opts) {
        const barBottom = this.bar.getBoundingClientRect().bottom;
        const top = opts.getBoundingClientRect().top;
        const delta = top - barBottom - 12;
        if (Math.abs(delta) > 8) window.scrollBy({ top: delta, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        if (!reduceMotion.matches) { opts.classList.remove('is-nudge'); void opts.offsetWidth; opts.classList.add('is-nudge'); }
      }
      this.#announce(this.nextLabel.textContent);
    }

    #scope(i) { return i === 1 ? this.#group('cats') : this.steps[i]; }

    #goto(index, instant, backwards) {
      const from = this.current;
      this.current = index;
      this.results.hidden = true;
      this.stage.hidden = false;
      const dir = backwards ?? index < from;
      this.steps.forEach((step, i) => {
        step.hidden = i !== index;
        step.classList.remove('is-in', 'is-in-back');
        if (i === index && !instant && !reduceMotion.matches) { void step.offsetWidth; step.classList.add(dir ? 'is-in-back' : 'is-in'); }
      });
      if (index === 2 || index === 3) this.#bands(); // prefetch the budget thumbnails one step early
      this.#sync();
      if (!instant) {
        const top = this.stage.getBoundingClientRect().top;
        if (Math.abs(top) > 4 && (index > 0 || top < 0)) this.stage.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
        const scope = this.#scope(index);
        const first = scope?.querySelector('.fym-in:checked') || scope?.querySelector('.fym-in');
        first?.focus({ preventScroll: true });
      }
    }

    /** Bar, progress, CTA and meter reflect the current step + answers. */
    #sync() {
      const i = this.current;
      const step = this.steps[i];
      const d = this.dataset;
      this.stepNo.textContent = (d.lStep || 'Step [n] of 5').replace('[n]', String(i + 1));
      this.names.forEach((n, j) => { n.classList.toggle('is-current', j === i); n.classList.toggle('is-done', j < i); });
      this.fill.style.setProperty('--p', String((i + 1) / 5));
      this.track.setAttribute('aria-valuenow', String(i + 1));
      this.qEl.textContent = step.dataset.q || '';
      this.hintText.textContent = step.dataset.hint || '';
      this.toggleAttribute('data-multi', i === 1);
      this.backBtn.hidden = i === 0;

      const ok = this.#answered(i);
      const last = i === this.steps.length - 1;
      let label;
      if (!ok) label = i === 1 ? d.lAtleast : d.lPickone;
      else label = last ? d.lShow : d.lNext;
      const was = this.nextBtn.getAttribute('aria-disabled') === 'true';
      this.nextBtn.setAttribute('aria-disabled', String(!ok));
      // single-choice steps advance on tap, so their CTA only appears once there is an answer to confirm
      this.cta.hidden = !ok && i === 0; // step 1 photo tiles advance on tap; later steps always show where the CTA lives
      this.nextLabel.textContent = label || '';
      const old = this.nextBtn.querySelector('.fym__next-count');
      old?.remove();
      if (ok && i === 1) {
        const c = document.createElement('span');
        c.className = 'fym__next-count';
        c.textContent = String(this.state.cats.length);
        c.setAttribute('aria-label', `${this.state.cats.length} ${d.lPicked || 'picked'}`);
        this.nextBtn.insertBefore(c, this.nextLabel);
      }
      if (was && ok && !reduceMotion.matches) { this.nextBtn.classList.remove('is-live'); void this.nextBtn.offsetWidth; this.nextBtn.classList.add('is-live'); }
      this.#peek();
      if (this.meter) this.meter.style.setProperty('--m', `${({ gentle: 1 / 3, medium: 2 / 3, intense: 1 }[this.state.mood] || 0) * 100}%`);
    }

    #announce(m) {
      if (!this.status) return;
      this.status.textContent = '';
      requestAnimationFrame(() => { this.status.textContent = m; });
    }

    /** @param {MouseEvent} e */
    #onClick(e) {
      const t = e.target;
      const tapped = t.closest('.fym__opts label');
      if (tapped && this.reTap && tapped.contains(this.reTap) && this.reTap.checked) {
        // tapping the answer that was already chosen (e.g. after Back) moves on, like a fresh tap
        this.reTap = null;
        this.#pop(tapped);
        clearTimeout(this.advT);
        this.advT = setTimeout(() => this.#next(), reduceMotion.matches ? 120 : 300);
        return;
      }
      const add = t.closest('[data-quiz-add]');
      if (add) { this.#add(add); return; }
      if (t.closest('[data-next]')) { this.#next(); return; }
      if (t.closest('[data-back]')) { this.#goto(Math.max(0, this.current - 1), false, true); return; }
      if (t.closest('[data-refine]')) { this.#goto(this.steps.length - 1, false, true); return; }
      const edit = t.closest('[data-edit]');
      if (edit) { this.#goto(Number(edit.dataset.edit), false, true); return; }
      if (t.closest('[data-more-btn]')) { this.shown += 12; this.#render(this.shown - 12); return; }
      if (t.closest('[data-restart]')) {
        this.form.reset();
        this.state = { cats: [] };
        this.#read();
        try { sessionStorage.removeItem(STORE_KEY); history.replaceState(null, '', window.location.pathname); } catch { /* ignore */ }
        this.#goto(0, false, true);
      }
    }

    /* ---------------- data ---------------- */
    /** @param {string} who */
    #load(who) {
      if (this.data[who]) return this.data[who];
      const url = this.dataset[`src${who.charAt(0).toUpperCase()}${who.slice(1)}`];
      const key = `fym:${url}`;
      this.data[who] = (async () => {
        let json = null;
        try { const cached = sessionStorage.getItem(key); if (cached) json = JSON.parse(cached); } catch { /* storage unavailable */ }
        if (!json) {
          const fallback = this.dataset[`fallback${who.charAt(0).toUpperCase()}${who.slice(1)}`];
          let text = null;
          for (const u of [url, fallback].filter((x, i, arr) => x && arr.indexOf(x) === i)) {
            try {
              const res = await fetch(u, { credentials: 'omit' });
              if (res.ok) { text = await res.text(); json = JSON.parse(text); break; }
            } catch { /* try the fallback */ }
          }
          if (!json) throw new Error('index unavailable');
          try { sessionStorage.setItem(key, text); } catch { /* quota or private mode */ }
        }
        const idx = Object.fromEntries(json.k.map((name, i) => [name, i]));
        const rows = json.r.map((r) => ({ h: r[idx.h], t: r[idx.t], v: json.v[r[idx.v]] || '', p: r[idx.p], i: r[idx.i], c: r[idx.c], n: r[idx.n], b: r[idx.b], a: r[idx.a], s: r[idx.s], x: r[idx.x] })).filter((row) => !QUIZ_ACCESSORY.test(row.t || ''));
        return { rows, img: json.img };
      })();
      this.data[who].catch(() => { delete this.data[who]; });
      return this.data[who];
    }

    #catSet(who, groups) {
      const map = QUIZ_GROUPS[who] || {};
      const keys = groups.includes('surprise') ? Object.keys(map).filter((g) => !QUIZ_NOT_SURPRISE.has(g)) : groups;
      const set = new Set();
      let remote = false;
      for (const g of keys) for (const c of map[g] || []) { if (c === '@remote') remote = true; else set.add(c); }
      return { set, remote };
    }

    #src(r, w, img = this.img) {
      const base = /^https?:/.test(r.i) ? r.i : img + r.i;
      return `${base}${base.includes('?') ? '&' : '?'}width=${w}`;
    }

    /** Budget step: live count + best-selling thumbnail per band for the chosen audience and categories. */
    async #bands() {
      const { who, cats } = this.state;
      if (!who) return;
      let data;
      try { data = await this.#load(who); } catch { return; }
      const { set, remote } = this.#catSet(who, cats);
      const toyish = (r) => !QUIZ_NOT_SURPRISE.has(r.c) && r.c !== 'bondage';
      const pool = data.rows.filter((r) => set.has(r.c) || (remote && (r.x & 18) && toyish(r)));
      for (const label of this.querySelectorAll('[data-key="budget"] label')) {
        const [lo, hi] = QUIZ_BANDS[label.dataset.value] || QUIZ_BANDS.any;
        const inBand = pool.filter((r) => r.p >= lo && r.p <= hi);
        const count = label.querySelector('[data-band-count]');
        if (count) count.textContent = inBand.length ? `${inBand.length.toLocaleString('en-NZ')} ${inBand.length === 1 ? 'match' : 'matches'}` : 'Close matches';
        const best = inBand.filter((r) => r.i).sort((a, b) => (b.x & 1) - (a.x & 1) || b.s - a.s)[0];
        const img = label.querySelector('[data-band-img]');
        if (img && best) {
          const src = this.#src(best, 160, data.img);
          if (img.getAttribute('src') !== src) { img.src = src; img.srcset = `${this.#src(best, 120, data.img)} 120w, ${src} 160w, ${this.#src(best, 240, data.img)} 240w`; img.sizes = '(min-width: 900px) 180px, 60px'; }
          img.loading = 'eager';
          img.hidden = false;
        } else if (img) img.hidden = true;
      }
    }

    /** Live "N toys match so far" strip on steps 3-5: counts and thumbnails from the answers given so far. */
    async #peek() {
      const el = this.peekEl;
      if (!el) return;
      const i = this.current;
      const { who, cats, mood, budget } = this.state;
      if (i < 2 || !who || !cats.length) { el.hidden = true; return; }
      const token = (this.peekToken = (this.peekToken || 0) + 1);
      let data;
      try { data = await this.#load(who); } catch { el.hidden = true; return; }
      if (token !== this.peekToken) return;
      const { set, remote } = this.#catSet(who, cats);
      const toyish = (r) => !QUIZ_NOT_SURPRISE.has(r.c) && r.c !== 'bondage';
      let pool = data.rows.filter((r) => set.has(r.c) || (remote && (r.x & 18) && toyish(r)));
      if (budget && i >= 4) { const [lo, hi] = QUIZ_BANDS[budget] || QUIZ_BANDS.any; pool = pool.filter((r) => r.p >= lo && r.p <= hi); }
      if (!pool.length) { el.hidden = true; return; }
      const target = MOOD_N[mood];
      const top = pool.filter((r) => r.i)
        .map((r) => ({ r, k: (target ? -12 * Math.abs(r.n - target) : 0) + (r.x & 1 ? 10 : 0) + r.s * 0.35 + quizHash(r.h) }))
        .sort((a, b) => b.k - a.k).slice(0, 4).map((o) => o.r);
      this.peekCount.textContent = pool.length.toLocaleString('en-NZ');
      const key = top.map((r) => r.h).join('|');
      if (key !== this.peekKey) {
        this.peekKey = key;
        this.peekThumbs.innerHTML = top.map((r) => `<img src="${quizEsc(this.#src(r, 120, data.img))}" srcset="${quizEsc(this.#src(r, 120, data.img))} 1x, ${quizEsc(this.#src(r, 180, data.img))} 2x" width="58" height="58" alt="" decoding="async">`).join('');
      }
      el.hidden = false;
    }

    /* ---------------- results ---------------- */
    async #show(fromUrl) {
      const { who, mood, budget, exp, cats } = this.state;
      this.stage.hidden = true;
      this.results.hidden = false;
      this.results.classList.remove('is-in');
      this.resTitle.textContent = this.dataset.lLoading || '';
      this.countEl.textContent = '';
      this.answersEl.replaceChildren();
      this.tip.hidden = true;
      this.pairs.hidden = true;
      this.grid.replaceChildren();
      this.loading.hidden = false;
      this.moreBtn.hidden = true;
      if (!fromUrl) this.results.scrollIntoView({ behavior: 'auto', block: 'start' });
      this.results.focus({ preventScroll: true });

      let data;
      try { data = await this.#load(who); } catch {
        this.loading.hidden = true;
        this.resTitle.textContent = 'Sorry, we couldn’t load your matches.';
        this.countEl.textContent = 'Check your connection and tap Refine answers to try again.';
        return;
      }
      this.img = data.img;
      const { set, remote } = this.#catSet(who, cats);
      const toyish = (r) => !QUIZ_NOT_SURPRISE.has(r.c) && r.c !== 'bondage';
      const inCats = (r, s) => s.has(r.c) || (remote && (r.x & 18) && toyish(r));
      const [lo, hi] = QUIZ_BANDS[budget] || QUIZ_BANDS.any;
      let pool = data.rows.filter((r) => inCats(r, set) && r.p >= lo && r.p <= hi);
      let widened = false;
      // Fix 2026-09-29 (CRO3-01, Fair Trading Act s13): the budget band is never widened any more, so every
      // card is inside the band the shopper chose. Only the category search widens when matches are few.
      if (pool.length < 6) {
        const wide = new Set(set);
        for (const c of set) for (const rc of QUIZ_RELATED[c] || []) wide.add(rc);
        pool = data.rows.filter((r) => inCats(r, wide) && r.p >= lo && r.p <= hi);
        widened = true;
      }

      const target = MOOD_N[mood] || 2;
      for (const r of pool) {
        let sc = 30 - 15 * Math.abs(r.n - target);
        if (exp === 'new') sc += (r.b ? 30 : -8) - (r.a ? 40 : 0);
        else if (exp === 'know') sc += (r.a ? 30 : 0) - (r.b ? 15 : 0) + (r.x & 2 ? 10 : 0) + (r.x & 4 ? 12 : 0) + (r.x & 16 ? 5 : 0);
        else sc += (r.b && !r.a ? 6 : 0) + (r.a ? -4 : 0) + (r.x & 4 ? 5 : 0);
        sc += r.s * 0.35 + (r.x & 1 ? 10 : 0) + (r.x & 4 ? 4 : 0) + (r.x & 8 ? 3 : 0);
        if (Object.prototype.hasOwnProperty.call(this.picks, r.h)) sc += 15;
        if (!set.has(r.c) && !(remote && (r.x & 18))) sc -= 20; // widened category
        if (!r.i) sc -= 50;
        r.score = sc + quizHash(r.h) * 2;
      }
      pool.sort((a, b) => b.score - a.score);
      // R3D-20: one card per product family (colour/texture/size variants listed as separate products)
      const fam = (r) => `${r.v}|${(r.t || '').toLowerCase().replace(/\(.*?\)/g, ' ').split(/\s[-–—|]\s/)[0]
        .replace(/\b(black|white|pink|purple|blue|red|green|teal|grey|gray|silver|gold|rose|nude|flesh|vanilla|chocolate|caramel|mocha|clear|light|dark|beige|tan|brown|lilac|lavender|coral|veined|smooth|textured|ribbed|small|medium|large|x-?large|xl|xxl|mini|\d+(\.\d+)?\s?(cm|mm|inch|in|"))\b/g, ' ')
        .replace(/[^a-z0-9]+/g, ' ').trim()}`;
      const seenFam = new Set();
      pool = pool.filter((r) => { const k = fam(r); if (seenFam.has(k)) return false; seenFam.add(k); return true; });
      const nGroups = cats.includes('surprise') ? 4 : cats.length;
      this.ranked = this.#diversify(pool, nGroups > 1 ? Math.max(3, Math.ceil(12 / nGroups)) : 12);
      this.catSetNow = set;
      this.remoteNow = remote;
      this.band = budget && budget !== 'any' ? [lo, hi] : null; // every card must honour this at its LIVE price
      this.shown = 12;
      if (this.sortSel) this.sortSel.value = 'match';
      this.widened.hidden = !widened;
      if (widened) this.widened.textContent = this.dataset.widenedText || '';
      this.#answers();
      this.#tip();
      await this.#render();
      this.#extras(data.rows, set);

      const cap = who.charAt(0).toUpperCase() + who.slice(1);
      const url = this.dataset[`see${cap}`];
      const title = this.dataset[`see${cap}Title`];
      if (this.seeAll && url) { this.seeAll.href = url; const t = this.seeAll.querySelector('[data-see-title]'); if (t && title) t.textContent = title; }
      try {
        const q = new URLSearchParams({ who, cats: cats.join(','), mood, budget, exp });
        history.replaceState(null, '', `${window.location.pathname}?${q}`);
      } catch { /* ignore */ }
      if (!reduceMotion.matches) {
        this.results.classList.add('is-in');
        if (this.burst) { this.burst.classList.remove('is-burst'); void this.burst.offsetWidth; this.burst.classList.add('is-burst'); }
      }
    }

    /** Answer chips: each one jumps back to its question (answers are kept). */
    #answers() {
      const label = (k) => this.#group(k)?.querySelector('.fym-in:checked')?.closest('label')?.querySelector('[data-label]')?.textContent.trim();
      const catLabels = this.state.cats.map((c) => this.#group('cats')?.querySelector(`.fym-in[value="${CSS.escape(c)}"]`)?.closest('label')?.querySelector('[data-label]')?.textContent.trim()).filter(Boolean);
      const items = [[0, label('who')], [1, catLabels.length > 2 ? `${catLabels.slice(0, 2).join(', ')} +${catLabels.length - 2}` : catLabels.join(', ')], [2, label('mood')], [3, label('budget')], [4, label('exp')]];
      this.answersEl.innerHTML = items.filter(([, t]) => t).map(([i, t]) => `<li><button type="button" class="fym__answer" data-edit="${i}" aria-label="Change: ${quizEsc(t)}">${quizEsc(t)} ${ICON_EDIT}</button></li>`).join('');
    }

    #diversify(list, catCap) {
      const out = [];
      let rest = list.slice();
      while (rest.length) {
        const vend = {}; const cat = {}; const page = [];
        const take = (r) => { page.push(r); vend[r.v] = (vend[r.v] || 0) + 1; cat[r.c] = (cat[r.c] || 0) + 1; };
        for (const ok of [(r) => (vend[r.v] || 0) < 2 && (cat[r.c] || 0) < catCap, (r) => (vend[r.v] || 0) < 2, () => true]) {
          for (const r of rest) { if (page.length >= 12) break; if (!page.includes(r) && ok(r)) take(r); }
        }
        out.push(...page);
        rest = rest.filter((r) => !page.includes(r));
      }
      return out;
    }

    #sorted() {
      const mode = this.sortSel?.value || 'match';
      const list = this.ranked.slice();
      if (mode === 'best') list.sort((a, b) => (b.x & 1) - (a.x & 1) || b.s - a.s || b.score - a.score);
      else if (mode === 'low') list.sort((a, b) => a.p - b.p);
      else if (mode === 'high') list.sort((a, b) => b.p - a.p);
      return list;
    }

    /**
     * Live price + availability for one product from /products/<handle>.js, cached per page view.
     * Resolves to { p, v } (cents of the first available variant, which is what the product page shows
     * and what Add to bag adds) or null when it is sold out, unpublished or cannot be read.
     */
    #live(r) {
      if (!this.liveCache.has(r.h)) {
        this.liveCache.set(r.h, fetch(`/products/${encodeURIComponent(r.h)}.js`, { headers: { Accept: 'application/json' } })
          .then((res) => (res.ok ? res.json() : null))
          .then((prod) => {
            if (!prod || !prod.available) return null;
            const v = (prod.variants || []).find((x) => x.available);
            return v ? { p: Number(v.price), v: v.id } : null;
          })
          .catch(() => null));
      }
      return this.liveCache.get(r.h);
    }

    /** Verify candidates in order (in parallel batches) until `target` pass: available and inside the budget band. */
    async #fill(target, token) {
      while (this.ok.length < target && this.ptr < this.order.length) {
        const batch = this.order.slice(this.ptr, this.ptr + (target - this.ok.length) + 4);
        this.ptr += batch.length;
        const lives = await Promise.all(batch.map((r) => this.#live(r)));
        if (token !== this.fillToken) return false;
        batch.forEach((r, i) => {
          const L = lives[i];
          if (!L) return;
          if (this.band && (L.p < this.band[0] || L.p > this.band[1])) return;
          this.ok.push({ ...r, p: L.p });
        });
      }
      return true;
    }

    async #render(from = 0) {
      const token = (this.fillToken = (this.fillToken || 0) + 1);
      const mode = this.sortSel?.value || 'match';
      if (from === 0) { this.order = this.#sorted(); this.ok = []; this.ptr = 0; this.grid.replaceChildren(); }
      this.loading.hidden = false; // skeleton, never a stale price
      this.moreBtn.hidden = true;
      if (from === 0 && this.actions) this.actions.hidden = true; // appears with the cards, so nothing below them jumps
      if (!(await this.#fill(this.shown, token))) return;
      this.loading.hidden = true;
      if (this.actions) this.actions.hidden = false;
      let list = this.ok.slice(0, this.shown);
      if (mode === 'low') list.sort((a, b) => a.p - b.p);
      else if (mode === 'high') list.sort((a, b) => b.p - a.p);
      const resort = mode === 'low' || mode === 'high';
      if (resort || from === 0) this.grid.innerHTML = list.map((r, i) => this.#card(r, i)).join('');
      else this.grid.insertAdjacentHTML('beforeend', list.slice(from).map((r, i) => this.#card(r, i)).join(''));
      const d = this.dataset;
      const total = this.order.length;
      const shown = list.length;
      this.resTitle.textContent = shown ? (d.resHeading || '').replace('[shown]', String(Math.min(12, shown))) : 'No exact matches yet';
      this.countEl.textContent = shown
        ? (d.countText || '').replace('[count]', Math.max(total, shown).toLocaleString('en-NZ')).replace('[shown]', String(shown))
        : 'Try a different budget or add another type. Tap an answer below to change it.';
      this.moreBtn.hidden = !(this.ok.length > this.shown || this.ptr < this.order.length);
      if (shown && shown < 6 && this.band && this.ptr >= this.order.length) {
        const b = this.#group('budget')?.querySelector('.fym-in:checked')?.closest('label')?.querySelector('[data-label]')?.textContent.trim();
        this.widened.hidden = false;
        this.widened.textContent = `Only ${shown} ${shown === 1 ? 'toy fits' : 'toys fit'} ${b || 'your budget'} right now. Tap the budget above to see more.`;
      }
      if (from > 0) this.grid.children[from]?.querySelector('.fym-card__title a')?.focus({ preventScroll: false });
    }

    #money(cents) { return `${this.dataset.currency || '$'}${(cents / 100).toFixed(2)}`; }

    /** Why it matched: short, true chips from the shopper's own answers. */
    /**
     * Why it matched: one chip from the shopper's answers (the type they picked), then up to two REAL
     * attributes of this product (so chips differ card to card), then the heat/budget match if space.
     */
    #chips(r) {
      const out = [];
      const txt = (k) => this.#group(k)?.querySelector('.fym-in:checked')?.closest('label')?.querySelector('[data-label]')?.textContent.trim();
      if (Object.prototype.hasOwnProperty.call(this.picks, r.h)) out.push(['Our pick', true]);
      const map = QUIZ_GROUPS[this.state.who] || {};
      const catKey = this.state.cats.find((k) => (map[k] || []).includes(r.c)) || (this.state.cats.includes('surprise') ? Object.keys(map).find((k) => (map[k] || []).includes(r.c)) : null);
      const catLabel = catKey && this.querySelector(`[data-key="cats"][data-for="${CSS.escape(this.state.who)}"] .fym-in[value="${CSS.escape(catKey)}"]`)?.closest('label')?.querySelector('[data-label]')?.textContent.trim();
      if (catLabel && catLabel.length < 22 && catKey !== 'surprise') out.push([catLabel]);
      const t = r.t || '';
      const attrs = [];
      if (r.x & 16 && !(r.x & 2)) attrs.push('Remote control');
      if (r.x & 2) attrs.push('App control');
      if (/recharg|usb/i.test(t)) attrs.push('Rechargeable');
      if (/waterproof|water-resistant|splashproof/i.test(t)) attrs.push('Waterproof');
      if (r.x & 8) attrs.push('Silicone');
      if (/warming|heat/i.test(t)) attrs.push('Warming');
      if (/rotat|thrust/i.test(t)) attrs.push(/rotat/i.test(t) ? 'Rotating' : 'Thrusting');
      if (r.x & 1) attrs.push('Bestseller');
      if (/vibrat/i.test(t) && !/vibrator/i.test(catLabel || '')) attrs.push('Vibrating');
      if (/textur|ribbed|nubbed/i.test(t)) attrs.push('Textured');
      if (/realistic|lifelike/i.test(t)) attrs.push('Realistic');
      if (/double|dual/i.test(t)) attrs.push('Dual action');
      if (/\bmini\b|compact|pocket|travel/i.test(t)) attrs.push('Compact');
      if (/suction/i.test(t)) attrs.push('Suction');
      if (r.b && this.state.exp !== 'know') attrs.push('Beginner-friendly');
      else if (r.a && this.state.exp === 'know') attrs.push('For experienced play');
      if (r.x & 4) attrs.push('Premium brand');
      for (const a of attrs) { if (out.length >= 3) break; if (!out.some(([x]) => x === a)) out.push([a]); }
      if (out.length < 3 && r.n === MOOD_N[this.state.mood]) out.push([txt('mood')]);
      const [lo, hi] = QUIZ_BANDS[this.state.budget] || QUIZ_BANDS.any;
      if (out.length < 3 && this.state.budget !== 'any' && r.p >= lo && r.p <= hi) out.push([txt('budget')]);
      return out.filter(([x]) => x).slice(0, 3);
    }

    #card(r, i) {
      const url = `/products/${encodeURIComponent(r.h)}`;
      const id = `NhqC-${r.h}`;
      const afterpay = (this.dataset.afterpay || '').replace('[amount]', this.#money(Math.round(r.p / 4)));
      const badge = r.x & 1 && this.dataset.badge ? `<span class="fym-card__badge">${quizEsc(this.dataset.badge)}</span>` : '';
      const img = r.i
        ? `<img class="fym-card__img" src="${quizEsc(this.#src(r, 400))}" srcset="${[300, 400, 600].map((w) => `${quizEsc(this.#src(r, w))} ${w}w`).join(', ')}" sizes="(min-width: 1100px) 290px, (min-width: 750px) 30vw, 46vw" width="600" height="600" loading="lazy" decoding="async" alt="${quizEsc(r.t)}">`
        : '';
      const chips = this.#chips(r).map(([t, on]) => `<li${on ? ' class="is-pick"' : ''}>${quizEsc(t)}</li>`).join('');
      return `<li class="fym-card" style="--i:${i % 12}" aria-labelledby="${quizEsc(id)}">
<a class="fym-card__media" href="${url}" tabindex="-1" aria-hidden="true">${img}${badge}</a>
<div class="fym-card__body">
<p class="fym-card__brand">${quizEsc(r.v)}</p>
<h3 class="fym-card__title" id="${quizEsc(id)}"><a href="${url}">${quizEsc(r.t)}</a></h3>
${chips ? `<ul class="fym-card__why" aria-label="Why it matched">${chips}</ul>` : ''}
<div class="fym-card__foot"><p class="fym-card__price">${this.#money(r.p)}<span class="fym-card__ap">${quizEsc(afterpay)}</span></p>
<button type="button" class="fym-card__add" data-quiz-add="${quizEsc(r.h)}" aria-label="${quizEsc(this.dataset.lAdd || 'Add to bag')}: ${quizEsc(r.t)}">${ICON_BAG}<span>${quizEsc(this.dataset.lAdd || 'Add to bag')}</span></button></div>
</div></li>`;
    }

    #tip() {
      const { cats, exp } = this.state;
      const first = cats.find((c) => c !== 'surprise') || 'bullet';
      const tipKey = QUIZ_TIPS[first] ? first : (QUIZ_GROUPS[this.state.who]?.[first]?.[0] || first);
      const tips = QUIZ_TIPS[tipKey];
      const tipText = this.querySelector('[data-tip-text]');
      if (tips && tipText) { tipText.textContent = exp === 'know' ? tips[1] : tips[0]; this.tip.hidden = false; } else this.tip.hidden = true;
    }

    async #extras(rows, set) {
      const { cats } = this.state;

      const pairGrid = this.querySelector('[data-pairs-grid]');
      const note = this.querySelector('[data-pairs-note]');
      if (set.has('lube') || !pairGrid) { this.pairs.hidden = true; return; }
      const anal = cats.includes('anal') || cats.includes('prostate');
      const lubes = rows.filter((r) => r.c === 'lube' && r.i && /water/i.test(r.t) && (anal || !/anal/i.test(r.t)));
      let pickL = lubes
        .map((r) => ({ r, k: (anal && /anal/i.test(r.t) ? 50 : 0) + r.s + (r.x & 1 ? 20 : 0) + quizHash(r.h) }))
        .sort((a, b) => b.k - a.k).slice(0, 6).map((o) => o.r);
      const lives = await Promise.all(pickL.map((r) => this.#live(r)));
      pickL = pickL.map((r, i) => (lives[i] ? { ...r, p: lives[i].p } : null)).filter(Boolean).slice(0, 2);
      if (!pickL.length) { this.pairs.hidden = true; return; }
      note.textContent = anal
        ? 'Anal play needs plenty of lube: a thicker water-based formula is safe with every toy.'
        : 'Water-based lube is safe with every toy, including silicone (silicone lube can damage silicone toys).';
      pairGrid.innerHTML = pickL.map((r, i) => this.#card(r, i)).join('');
      this.pairs.hidden = false;
    }

    /** @param {HTMLButtonElement} button */
    async #add(button) {
      if (button.getAttribute('aria-busy') === 'true') return;
      button.setAttribute('aria-busy', 'true');
      const handle = button.dataset.quizAdd;
      const label = button.querySelector('span');
      try {
        const pr = await fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
        const product = await pr.json();
        const variant = (product.variants || []).find((v) => v.available);
        if (!variant) { this.#announce('Sorry, this one has just sold out.'); return; }
        if (product.variants.length > 1 && product.variants.filter((v) => v.available).length > 1 && product.options?.length && product.options[0] !== 'Title') {
          window.location.href = `/products/${encodeURIComponent(handle)}`; // several options: choose on the product page
          return;
        }
        const url = window.theme?.routes?.cartAdd || '/cart/add.js';
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variant.id, quantity: 1 }),
        });
        const data = await res.json();
        if (!res.ok || data.status) { this.#announce(data.description || data.message || 'Sorry, that could not be added.'); return; }
        this.#announce('Added to your bag');
        button.classList.add('is-added');
        button.innerHTML = `${ICON_TICK}<span>${quizEsc(this.dataset.lAdded || 'Added')}</span>`;
        if (navigator.vibrate) { try { navigator.vibrate(12); } catch { /* ignore */ } }
        button.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data, addToCartBtn: button }, bubbles: true }));
        if (window.theme?.settings?.cartType === 'page') window.location.href = window.theme.routes.cartPage;
      } catch {
        window.location.href = `/products/${encodeURIComponent(handle)}`;
      } finally {
        button.removeAttribute('aria-busy');
        void label;
      }
    }
  }

  customElements.define('nh-quiz', NhQuiz);
})();
